'use client';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "prefixCls"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import FlexBasic from "../FlexBasic";
import { getPrefix } from "../utils";
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Center = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    res = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(FlexBasic, _objectSpread(_objectSpread({
    ref: ref,
    internalClassName: "".concat(getPrefix(prefixCls), "-center"),
    className: className
  }, res), {}, {
    align: 'center',
    justify: 'center',
    children: children
  }));
});
export default Center;